import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  Typography,
} from "@mui/material";
import "../../styles/UserStyles.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import {
  BOOKING_PASSENGER_DETAILS,
  BOOKINGS,
} from "../../component/common/Routes/AppRoutes";
import "../../styles/UserStyles.css";
import ControlledTextInputField from "../../component/ui/FormFields/ControlledTextInputField";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllAirportRequest } from "../../redux/Airports/actions/airportActions";
import { fetchAllServiceRequest } from "../../redux/Service/ServiceAction";
import CustomButton from "../../component/ui/FormFields/Button";
import {
  VENDOR_BOOKING_PASSENGER_DETAILS,
  VENDOR_BOOKINGS,
} from "../../component/common/Routes/VendorRoutes";
import {
  CUSTOMER_BOOKING_PASSENGER_DETAILS,
  CUSTOMER_BOOKINGS,
} from "../../component/common/Routes/CustomerRoutes";
import {
  fetchServiceTypeRequest,
  fetchTransitServiceTypeRequest,
  resetBookingDetails,
} from "../../redux/Bookings/BookingAction";
import {
  fetchDropdownCustomersRequest,
} from "../../redux/Customers/actions/customerActions";
import { StarSymbol } from "../../Style";
import { fetchCustomersByVendorRequest } from "../../redux/Vendors/actions/vendorActions";
import dayjs from "dayjs";
const AirPortDetails = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const location = useLocation();

  const form1Value =
    location.state?.form1Value || location.state?.formData || {};
  const form2Value = location.state?.form2Value || {};
  const customerDetails = location.state?.customerDetails || {};
  const form3Value = location.state?.form3Value || {};



  const isIntantBooking = Object.keys(customerDetails).length > 0;
  const airport = useSelector(
    (state) => state.airport.airportsList?.data || {}
  );

  const {
    formState: { errors },
    control,
    reset,
    handleSubmit,
    watch,
    setError,
    clearErrors,

    setValue,
  } = useForm({
    defaultValues: {
      airport_type: form1Value?.airport_type,
      type_of_class: form1Value?.type_of_class,
      customer:
        form1Value?.customer ||
        customerDetails?.full_name ||
        customerDetails?.fullName ||
        form1Value?.customerDetails?.full_name ||
        "",
      airport: form1Value?.airport || "",
      arrival_plan: form1Value?.arrival_plan || "",
      departure_plan: form1Value?.departure_plan || "",
      arrival_departure_type: form1Value?.arrival_departure_type || "",
      service_type: form1Value?.service_type || "",
      transit_service: form1Value?.transit_service || "",
      arrival_city: form1Value?.arrival_city || "",
      departure_city: form1Value?.departure_city || "",
      departure_date: form1Value?.departure_date || 0,
      departure_time: form1Value?.departure_time || "",
      arrival_date: form1Value?.arrival_date || 0,
      arrival_time: form1Value?.arrival_time || "",
      arrival_airline: form1Value?.arrival_airline || "",
      departure_airline: form1Value?.departure_airline || "",
      arrival_flight_number: form1Value?.arrival_flight_number || "",
      departure_flight_number: form1Value?.departure_flight_number || "",
      arival_pnr_by_customer: form1Value?.arival_pnr_by_customer || "",
      departure_pnr_by_customer: form1Value?.departure_pnr_by_customer || "",
      transit_plan: form1Value?.transit_plan,
    },

    mode: "onChange",
  });

  const formValue = watch();
  const airport_name = formValue.airport.label;
  console.log("airport_name", airport_name);
  const customer = formValue?.customer?.value;

  const airportType = airport.filter((value) => {
    if (value?.id == formValue?.airport?.value) {
      const airportTypes = value?.airport_type;
      return airportTypes;
    }
  });
  const airportCategory = airportType[0]?.airport_type;
  useEffect(() => {
    dispatch(fetchAllAirportRequest());
    dispatch(fetchAllServiceRequest());
    if (user?.user_type === 2) {
      dispatch(
        fetchCustomersByVendorRequest({
          pagination_required: false,
          pagesize: 100,
          pageNo: 1,
          vendor_id: user?.vendor_id,
        })
      );
    } else {
      dispatch(fetchDropdownCustomersRequest());
    }
  }, []);

  const dropdownCustomers = useSelector(
    (state) => state.customers?.dropdownCustomers?.data
  );
  const vendorCustomers = useSelector(
    (state) => state.vendors?.customers
  );

  const customers =
    user?.user_type === 2
      ? (Array.isArray(vendorCustomers?.data)
          ? vendorCustomers.data
          : Array.isArray(vendorCustomers)
          ? vendorCustomers
          : [])
      : (Array.isArray(dropdownCustomers?.data)
          ? dropdownCustomers.data
          : Array.isArray(dropdownCustomers)
          ? dropdownCustomers
          : []);

  const filteredAirports = airport.filter((airport) => {
    if (airport?.status === 1 && airport?.approoved_status === 1) {
      return {
        airport,
      };
    }
  });

  const activeCustomers = customers.filter((customer) => {
    if (
      customer?.status !== undefined &&
      customer?.status !== null &&
      customer?.status !== 1
    ) {
      return false;
    }
    if (
      customer?.current_role !== undefined &&
      customer?.current_role !== null &&
      customer?.current_role !== 3
    ) {
      return false;
    }
    return true;
  });

  const serviceTypeDetail = useSelector(
    (state) => state.booking?.serviceType?.data?.AiportServices
  );

  const transitServiceTypeDetail = useSelector(
    (state) => state.booking?.transitServiceType?.data?.AiportServices
  );

  const viewCustomerField =
    user?.role === "Admin" || user?.role === "Vendor" || user?.role === "Staff";

  const airportTypes = [
    {
      label: "Airports In India",
      value: "Domestic",
    },
    {
      label: "Airports outside India",
      value: "International",
    },
  ];

  const travelClassTypes = [
    {
      label: "First class",
      value: "First class",
    },
    {
      label: "Business class",
      value: "Business class",
    },
    {
      label: "Premium Economy",
      value: "Premium Economy",
    },
    {
      label: "Economy",
      value: "Economy",
    },
  ];
  const orderdAirports = filteredAirports
    .map((airport) => {
      return {
        value: airport.id,
        label: airport.name,
        country: airport.country_id,
      };
    })
    .sort((a, b) => a.label.localeCompare(b.label));

  const airports = orderdAirports.filter((airport) => {
    return formValue?.airport_type?.value === "Domestic"
      ? airport?.country === 101
      : formValue?.airport_type?.value === "International"
        ? airport?.country !== 101
        : "";
  });
console.log("airports",airports)
  const services = serviceTypeDetail
    ?.map((service) => ({
      value: service?.service_id,
      label: service?.Service?.services,
      price: service?.price || 0,
    }))
    ?.sort((a, b) => b.price - a.price); // Descending order

  const transitServices = transitServiceTypeDetail
    ?.map((service) => ({
      value: service?.service_id,
      label: service?.Service?.services,
      price: service?.price || 0,
    }))
    ?.sort((a, b) => b.price - a.price);
  const customerOptions = activeCustomers.map((customer) => {
    const fullName =
      customer?.full_name ||
      customer?.display_name ||
      `${customer?.first_name || ""} ${customer?.last_name || ""}`.trim() ||
      "Customer";
    const serial = customer?.customer_serial_no
      ? `(${customer?.customer_serial_no})`
      : "";
    return {
      value: customer.id,
      label: `${fullName} ${serial}`.trim(),
    };
  });

  const typeOfAirport =
    formValue.airport_type?.value === "International"
      ? [{ value: "International", label: "International" }]
      : airportCategory === "International" || airportCategory === "Both"
        ? [
          { value: "Domestic", label: "Domestic" },
          { value: "International", label: "International" },
        ]
        : [{ value: "Domestic", label: "Domestic" }];

  const tableContent =
    formValue?.arrival_departure_type?.value === "Transit"
      ? transitServiceTypeDetail
        ?.map((value) => ({
          service: value?.Service?.services || "-",
          departure: value?.departure || "-",
          arrival: value?.arrival || "-",
          transit: value?.transit || "-",
          type_of_service: value?.Service?.type_of_service || "-",
          price: value?.price || 0,
        }))
        ?.sort((a, b) => b.price - a.price)
      : serviceTypeDetail
        ?.map((value) => ({
          service: value?.Service?.services || "-",
          departure: value?.departure || "-",
          arrival: value?.arrival || "-",
          transit: value?.transit || "-",
          type_of_service: value?.Service?.type_of_service || "-",
          price: value?.price || 0,
        }))
        ?.sort((a, b) => b.price - a.price);
  const transitServiceType = serviceTypeDetail
    ?.map((value) => ({
      label: value?.Service?.transit_name,
      value: value?.Service?.transit_type,
    }))
    .filter(
      (item, index, self) =>
        index === self.findIndex((t) => t.value === item.value)
    );

  const service = formValue.arrival_departure_type?.value;
  const airportName = formValue?.airport?.label;

  useEffect(() => {
    dispatch(resetBookingDetails());
  }, []);



  useEffect(() => {
    if (airportName !== form1Value?.airportName?.lebel) {
      reset({
        ...formValue,
        transit_plan: "",
        departure_plan: "",
        arrival_plan: ""

      });
    }

  }, [airportName])
  useEffect(() => {


    if (customer !== form1Value?.customer?.value) {

      navigate(location.pathname, {
        state: {
          ...location.state,
          form2Value: {},
          form3Value: {}
        },
        replace: true // avoids adding a new history entry
      });
    }
  }, [customer])
  useEffect(() => {
    if (formValue) {
      formValue?.arrival_departure_type?.value === "Departure"
        ? reset({
          ...formValue,
          arrival_city: "",
          arrival_date: 0,
          arrival_time: "",
          arrival_airline: "",
          arrival_flight_number: "",
          arival_pnr_by_customer: "",
          arrival_plan: "",
          transit_plan: "",
        })
        : formValue?.arrival_departure_type?.value === "Arrival"
          ? reset({
            ...formValue,
            departure_city: "",
            departure_date: 0,
            departure_time: "",
            departure_airline: "",
            departure_flight_number: "",
            departure_pnr_by_customer: "",
            transit_plan: "",
            departure_plan: "",
          })
          : reset({
            ...formValue,
          });
    }
  }, [service]);


  const taxs = airport?.filter((value) => {
    return value.id === formValue?.airport?.value;
  });

  const choosenService = serviceTypeDetail?.filter((value) => {
    return (
      value.service_id === formValue?.departure_plan?.value ||
      value.service_id === formValue?.arrival_plan?.value
    );
  });

  const choosenTransitService = serviceTypeDetail?.filter((value) => {
    return value.service_id === formValue?.transit_plan?.value;
  });

  const serviceType =
    airportCategory === "International" || airportCategory === "Both"
      ? [
        { value: "Arrival", label: "Arrival" },
        { value: "Departure", label: "Departure" },
        { value: "Transit", label: "Transit" },
      ]
      : [
        { value: "Arrival", label: "Arrival" },
        { value: "Departure", label: "Departure" },
      ];

  const servicePlanPrice =
    choosenService != undefined ? choosenService[0]?.price : " ";

  const transitServicePlanPrice =
    choosenTransitService != undefined ? choosenTransitService[0]?.price : " ";

  const servicePrice =
    servicePlanPrice > 0 ? servicePlanPrice : transitServicePlanPrice;

  const sgstAmount = (servicePrice * taxs[0]?.sgst) / 100;
  const cgstAmount = (servicePrice * taxs[0]?.cgst) / 100;
  const taxAmount = (servicePrice * taxs[0]?.tax) / 100;
  const sgst = sgstAmount;
  const cgst = cgstAmount;
  const tax = taxAmount;

  const formValue11 = {
    ...formValue,
    departure_date: formValue.departure_date || null,
    customerDetails:
      Object.keys(customerDetails || {}).length > 0
        ? customerDetails
        : form1Value?.customerDetails,
    arrival_date: formValue.arrival_date || null,
    sgst: sgst,
    cgst: cgst,
    tax: tax,
    tax_percentage: taxs[0]?.tax,
    sgst_percentage: taxs[0]?.sgst,
    cgst_percentage: taxs[0]?.cgst,
    servicePlanPrice:
      servicePlanPrice !== undefined
        ? servicePlanPrice
        : transitServicePlanPrice,
  };

  const service_type =
    formValue.arrival_departure_type?.value === "Arrival"
      ? 1
      : formValue.arrival_departure_type?.value === "Departure"
        ? 2
        : 3;
  const airport_type =
    formValue.service_type?.value === "Domestic"
      ? 1
      : formValue.service_type?.value === "International"
        ? 2
        : 3;
  const airport_id = formValue.airport?.value;
  const transit_type = formValue.transit_service?.value;

  useEffect(() => {
    if (
      formValue.service_type &&
      formValue.arrival_departure_type?.value &&
      formValue.airport
    ) {
      if (formValue.arrival_departure_type?.value !== "Transit") {
        dispatch(resetBookingDetails());
        dispatch(
          fetchServiceTypeRequest({
            service_type,
            airport_type,
            airport_id,
          })
        );
        setValue("transit_service", " ");
      }
    }
    if (
      formValue.arrival_departure_type?.value === "Transit" &&
      formValue.airport
    ) {
      dispatch(resetBookingDetails());
      dispatch(
        fetchServiceTypeRequest({
          service_type,
          airport_type: 3,
          airport_id,
        })
      );
    }
  }, [
    formValue.service_type,
    formValue.arrival_departure_type,
    formValue.airport,
  ]);

  useEffect(() => {
    if (formValue.transit_service?.value >= 0) {
      dispatch(
        fetchTransitServiceTypeRequest({
          transit_type,
          service_type,
          airport_id,
        })
      );
    }
  }, [formValue.transit_service, formValue.service_type]);
  const navigate = useNavigate();

  const fields = [
    {
      name: "airport_type",
      label: "Airport Type *",
      rules: { required: "Select Airport is required" },
      options: airportTypes,
      placeholder: "Select Airport type",
      sm: 6,
    },
    ...(viewCustomerField
      ? [
        Object.keys(customerDetails || {}).length > 0 ||
          (form1Value &&
            Object.keys(form1Value.customerDetails || {}).length > 0)
          ? // customerDetails !== undefined
          {
            name: "customer",
            label: "Customer *",
            rules: { required: "Customer is required" },
            placeholder: "Select Customer",
            disabled: true,
            sm: 6,
          }
          : {
            name: "customer",
            label: "Customer *",
            rules: { required: "Customer is required" },
            options: customerOptions,
            placeholder: "Select Customer",
            sm: 6,
          },
      ]
      : []),
    {
      name: "airport",
      label: "Airport *",
      rules: { required: "Airport is required" },
      options: airports,
      placeholder: "Select Airport",
      sm: 6,
    },
    {
      name: "type_of_class",
      label: "Travel Class *",
      rules: { required: "Select Travel Class is required" },
      options: travelClassTypes,
      placeholder: "Select Travel class type",
      sm: 6,
    },
    {
      name: "arrival_departure_type",
      label: "Arrival/Departure",
      rules: { required: "Arrival/Departure type is required" },
      options: serviceType,
      placeholder: "Select Arrival/Departure Type",
      sm: 6,
    },
    ...(service === "Transit"
      ? [
        {
          name: "transit_service",
          label: "Transit Service *",
          rules: { required: "Transit Service type is required" },
          options: transitServiceType || [],
          placeholder: "Transit Service Type",
          sm: 6,
        },
      ]
      : [
        {
          name: "service_type",
          label: "Service Type *",
          rules: { required: "Service type is required" },
          options: typeOfAirport,
          placeholder: "Select Service Type",
          sm: 6,
        },
      ]),
  ];
  const arrivalField = [
    {
      name: "arrival_airline",
      label: "Arrival Airline *",
      placeholder: "Enter Arrival Airline",
      rules: { required: "Arrival Airline is required" },
      type: "text",
      sm: 6,
    },
    {
      name: "arrival_flight_number",
      label: "Arrival Flight Number *",
      placeholder: "Enter Arrival Flight Number",
      rules: { required: "Flight Number is required" },
      type: "text",
      sm: 6,
    },
    {
      name: "arival_pnr_by_customer",
      label: "Arrival PNR Number *",
      placeholder: "Enter Arrival PNR Number",
      rules: { required: "Arrival PNR Number is required" },
      type: "text",
      sm: 6,
    },
    {
      name: "arrival_date",
      label: "Arrival Date *",
      placeholder: "",
      type: "datebooking",

      sm: 6,
      rules: {
        required: "Date of Arrival is required",
        validate: (value) => {
          if (!value) return "Date is required";

          // Parse the DD-MM-YYYY formatted string
          const selectedDate = dayjs(value, "DD-MM-YYYY");

          // Check if the date is valid
          if (!selectedDate.isValid()) {
            return "Invalid date format";
          }

          const today = dayjs().startOf("day");
          const minAllowedDate = dayjs().add(24, "hours").startOf("day");

          if (selectedDate.isBefore(today)) {
            return "Date cannot be in the past";
          }

          if (selectedDate.isBefore(minAllowedDate)) {
            return `Arrival date must be at least ${airportName == "Mumbai" ? 48 : 24} hours from now`;
          }

          return true;
        },
      },
    },
    {
      name: "arrival_time",
      label: "Arrival Time *",
      placeholder: "",
      type: "time",
      sm: 6,
      rules: {
        required: "Time of Arrival is required",
        validate: (_, formValues) => {
          const { arrival_date, arrival_time } = formValues;

          if (!arrival_date || !arrival_time)
            return "Date and Time are required";

          // Parse DD-MM-YYYY format properly
          const [day, month, year] = arrival_date.split("-");
          // Create a date string in YYYY-MM-DD format that JS can parse
          const dateFormatted = `${year}-${month}-${day}`;

          const selectedDateTime = new Date(`${dateFormatted}T${arrival_time}`);
          const minAllowedDateTime = new Date();

          minAllowedDateTime.setHours(minAllowedDateTime.getHours() + 24); // 24 hours from now
          const pastTimeCheck = new Date();

          return isIntantBooking
            ? selectedDateTime >= pastTimeCheck || "Future Time Must Select"
            : selectedDateTime >= minAllowedDateTime ||
            "Arrival must be at least 24 hours from now";
        },
      },
    },
    {
      name: "arrival_plan",
      label: "Service Plan *",
      rules: { required: "Plan is required" },
      options: services,
      placeholder: "Select Service Plan",
      sm: 6,
    },
  ];
  const departureField = [
    {
      name: "departure_airline",
      label: "Departure Airline *",
      placeholder: "Enter Departure Airline",
      rules: { required: "Departure Airline is required" },
      type: "text",
      sm: 6,
    },
    {
      name: "departure_flight_number",
      label: "Departure Flight Number *",
      placeholder: "Enter Departure Flight Number",
      rules: { required: "Flight Number is required" },
      type: "text",
      sm: 6,
    },
    {
      name: "departure_pnr_by_customer",
      label: "Departure PNR Number *",
      placeholder: "Enter Departure PNR Number",
      rules: { required: "Departure PNR Number is required" },
      type: "text",
      sm: 6,
    },
    {
      name: "departure_date",
      label: "Departure Date *",
      placeholder: "",

      type: "datebooking",
      sm: 6,
      rules: {
        required: "Date of Departure is required",
        validate: (value) => {
          if (!value) return "Date is required";

          // Parse the DD-MM-YYYY formatted string
          const selectedDate = dayjs(value, "DD-MM-YYYY");

          // Check if the date is valid
          if (!selectedDate.isValid()) {
            return "Invalid date format";
          }

          const today = dayjs().startOf("day");
          const minAllowedDate = dayjs().add(24, "hours").startOf("day");

          if (selectedDate.isBefore(today)) {
            return "Date cannot be in the past";
          }

          if (selectedDate.isBefore(minAllowedDate)) {
            return `Departure date must be at least ${airportName == "Mumbai" ? 48 : 24} hours from now`;
          }

          return true;
        },
      },
    },
    {
      name: "departure_time",
      label: "Departure Time *",
      placeholder: "",
      rules: {
        required: "Time of Departure is required",
        validate: (_, formValues) => {
          const { departure_date, departure_time } = formValues;

          if (!departure_date || !departure_time)
            return "Date and Time are required";

          // Parse DD-MM-YYYY format properly
          const [day, month, year] = departure_date.split("-");
          // Create a date string in YYYY-MM-DD format that JS can parse
          const dateFormatted = `${year}-${month}-${day}`;

          const selectedDateTime = new Date(
            `${dateFormatted}T${departure_time}`
          );
          const minAllowedDateTime = new Date();

          minAllowedDateTime.setHours(minAllowedDateTime.getHours() + 24); // 24 hours from now
          const pastTimeCheck = new Date();

          return isIntantBooking
            ? selectedDateTime >= pastTimeCheck || "Future Time Must Select"
            : selectedDateTime >= minAllowedDateTime ||
            "Departure must be at least 24 hours from now";
        },
      },
      type: "time",
      sm: 6,
    },
    {
      name: "departure_plan",
      label: "Service Plan *",
      rules: { required: "plan is required" },
      options: services,
      placeholder: "Select Service Plan",
      sm: 6,
    },
  ];
  const transitField = [
    {
      name: "arrival_airline",
      label: "Arrival Airline *",
      placeholder: "Enter Arrival Airline",
      rules: { required: "Arrival Airline is required" },
      type: "text",
      sm: 6,
    },
    {
      name: "departure_airline",
      label: "Departure Airline *",
      placeholder: "Enter Departure Airline",
      rules: { required: "Departure Airline is required" },
      type: "text",
      sm: 6,
    },
    {
      name: "arrival_city",
      label: "Arrival City *",
      placeholder: "Enter Arrival city",
      rules: { required: "Arrival City is required" },
      type: "text",
      sm: 6,
    },
    {
      name: "departure_city",
      label: "Departure City *",
      placeholder: "Enter Departure city",
      rules: { required: "Departure City is required" },
      type: "text",
      sm: 6,
    },
    {
      name: "arrival_flight_number",
      label: "Arrival Flight Number *",
      placeholder: "Enter Arrival Flight Number",
      rules: { required: "Flight Number is required" },
      type: "text",
      sm: 6,
    },
    {
      name: "arival_pnr_by_customer",
      label: "Arrival PNR Number *",
      placeholder: "Enter Arrival PNR Number",
      rules: { required: "Arrival PNR Number is required" },
      type: "text",
      sm: 6,
    },
    {
      name: "departure_flight_number",
      label: "Departure Flight Number *",
      placeholder: "Enter Departure Flight Number",
      rules: { required: "Flight Number is required" },
      type: "text",
      sm: 6,
    },
    {
      name: "departure_pnr_by_customer",
      label: "Departure PNR Number *",
      placeholder: "Enter Departure PNR Number",
      rules: { required: "Departure PNR Number is required" },
      type: "text",
      sm: 6,
    },
    {
      name: "arrival_date",
      label: "Arrival Date *",
      placeholder: "",

      rules: {
        required: "Date of Arrival is required",
        validate: (value) => {
          if (!value) return "Date is required";

          // Parse the DD-MM-YYYY formatted string
          const selectedDate = dayjs(value, "DD-MM-YYYY");

          // Check if the date is valid
          if (!selectedDate.isValid()) {
            return "Invalid date format";
          }

          const today = dayjs().startOf("day");
          const minAllowedDate = dayjs().add(24, "hours").startOf("day");

          if (selectedDate.isBefore(today)) {
            return "Date cannot be in the past";
          }

          if (selectedDate.isBefore(minAllowedDate)) {
            return `Arrival date must be at least ${airportName == "Mumbai" ? 48 : 24} hours from now`;
          }

          return true;
        },
      },
      type: "datebooking",
      sm: 6,
    },

    {
      name: "departure_date",
      label: "Departure Date *",
      placeholder: "",

      rules: {
        required: "Date of Departure is required",
        validate: (value, formValues) => {
          if (!value) return "Date is required";

          // Parse the DD-MM-YYYY formatted string
          const selectedDayjsDate = dayjs(value, "DD-MM-YYYY");
          if (!selectedDayjsDate.isValid()) {
            return "Invalid date format";
          }

          // Convert to JS Date for existing logic
          const selectedDate = selectedDayjsDate.toDate().setHours(0, 0, 0, 0);
          const today = new Date().setHours(0, 0, 0, 0);
          const notPastCheck =
            selectedDate >= today || "Date cannot be in the past";

          if (notPastCheck !== true) return notPastCheck;

          // For Transit bookings, check relation to arrival date
          if (
            formValues.arrival_departure_type?.value === "Transit" &&
            formValues.arrival_date
          ) {
            const departureDate = selectedDayjsDate
              .toDate()
              .setHours(0, 0, 0, 0);
            const arrivalDate = dayjs(formValues.arrival_date, "DD-MM-YYYY")
              .toDate()
              .setHours(0, 0, 0, 0);

            if (departureDate < arrivalDate) {
              return "Departure date must be on or after arrival date";
            }
          }

          return true;
        },
      },
      type: "datebooking",
      sm: 6,
    },
    {
      name: "arrival_time",
      label: "Arrival Time *",
      placeholder: "",
      type: "time",
      sm: 6,
      rules: {
        required: "Time of Arrival is required",
        validate: (_, formValues) => {
          const { arrival_date, arrival_time } = formValues;

          if (!arrival_date || !arrival_time)
            return "Date and Time are required";

          // Parse DD-MM-YYYY format properly
          const [day, month, year] = arrival_date.split("-");
          // Create a date string in YYYY-MM-DD format that JS can parse
          const dateFormatted = `${year}-${month}-${day}`;

          const selectedDateTime = new Date(`${dateFormatted}T${arrival_time}`);
          const minAllowedDateTime = new Date();

          minAllowedDateTime.setHours(minAllowedDateTime.getHours() + 24); // 24 hours from now
          const pastTimeCheck = new Date();

          return isIntantBooking
            ? selectedDateTime >= pastTimeCheck || "Future Time Must Select"
            : selectedDateTime >= minAllowedDateTime ||
            "Arrival must be at least 24 hours from now";
        },
      },
    },

    {
      name: "departure_time",
      label: "Departure Time *",
      placeholder: "",
      rules: {
        required: "Time of Departure is required",
        validate: (value, formValues) => {
          const { departure_date, departure_time } = formValues;

          if (!departure_date || !departure_time) {
            return "Date and Time are required";
          }

          // Parse using dayjs
          const departureDateTime = dayjs(
            `${departure_date} ${departure_time}`,
            "DD-MM-YYYY HH:mm"
          );

          if (!departureDateTime.isValid()) {
            return "Invalid departure date or time format";
          }

          const now = dayjs();
          const minAllowedDateTime = now.add(24, "hour");

          const timeCheck = isIntantBooking
            ? departureDateTime.isAfter(now) || "Future Time Must Select"
            : departureDateTime.isAfter(minAllowedDateTime) ||
            "Departure must be at least 24 hours from now";

          if (timeCheck !== true) return timeCheck;

          // Transit time constraint
          if (
            formValues.arrival_departure_type?.value === "Transit" &&
            formValues.arrival_date &&
            formValues.arrival_time
          ) {
            const arrivalDateTime = dayjs(
              `${formValues.arrival_date} ${formValues.arrival_time}`,
              "DD-MM-YYYY HH:mm"
            );

            if (!arrivalDateTime.isValid()) {
              return "Invalid arrival date or time format";
            }

            const diffHours = departureDateTime.diff(
              arrivalDateTime,
              "hour",
              true
            );
            if (diffHours < 3) {
              return "Transit time must be at least 3 hours";
            }

            if (diffHours > 6) {
              return "Transit time cannot exceed 6 hours";
            }
          }

          return true;
        },
      },

      type: "time",
      sm: 6,
    },
    {
      name: "transit_plan",
      label: "Transit Plan *",
      rules: { required: "plan is required" },
      options: transitServices,
      placeholder: "Select Service Plan",
      sm: 6,
    },
  ];

  return (
    <Box component={Paper} className="add_airport_details_heading">
      <Typography variant="h5" className="form-heading">
        Add Booking
      </Typography>
      <Box className="form-margin">
        <form
          onSubmit={handleSubmit((data) => {
            let passengerDetailsRoute;
            if (user.role === "Admin" || user.role === "Staff") {
              passengerDetailsRoute = BOOKING_PASSENGER_DETAILS;
            } else if (user.role === "Vendor") {
              passengerDetailsRoute = VENDOR_BOOKING_PASSENGER_DETAILS;
            } else if (user.role === "Customer") {
              passengerDetailsRoute = CUSTOMER_BOOKING_PASSENGER_DETAILS;
            }

            navigate(passengerDetailsRoute, {
              state: {
                form1Value: formValue11,
                form2Value: form2Value,
                form3Value: form3Value,
              },
            });
          })}
        >
          <Grid container spacing={4}>
            {fields.map((field, index) => (
              <Grid item xs={12} sm={field.sm} key={index}>
                <ControlledTextInputField
                  name={field.name}
                  control={control}
                  rules={field.rules}
                  type={field.type}
                  disabled={field.disabled}
                  setValue={setValue}
                  airportName={airport_name}
                  module={"booking"}
                  label={field.label}
                  placeholder={field.placeholder}
                  options={field.options}
                  getOptionLabel={(option) => option.label}
                  error={!!errors[field.name]}
                  helperText={errors[field.name]?.message}
                />
              </Grid>
            ))}
            {/* Table cotent */}
            {formValue?.arrival_departure_type?.value !== "Transit" &&
              formValue?.service_type?.value &&
              formValue?.airport?.value &&
              formValue?.arrival_departure_type?.value === "Arrival" ? (
              <Grid item xs={12}>
                <TableContainer component={Paper} className="form-margin">
                  <Table
                    sx={{ minWidth: 600, border: "none" }}
                    aria-label="Services Table"
                  >
                    <TableHead>
                      <TableRow
                        sx={{
                          display: "grid",
                          gridTemplateColumns: "1fr 3fr 1fr",
                        }}
                      >
                        <TableCell scope="col">Services</TableCell>
                        <TableCell scope="col" sx={{ textAlign: "center" }}>
                          Arrival
                        </TableCell>
                        <TableCell scope="col" sx={{ textAlign: "center" }}>
                          Price
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {tableContent?.length > 0 &&
                        tableContent[0]?.service !== undefined ? (
                        tableContent.map((row, index) => (
                          <TableRow
                            key={index}
                            sx={{
                              display: "grid",
                              gridTemplateColumns: "1fr 3fr 1fr",
                            }}
                          >
                            <TableCell>
                              {row.service}
                              {/* - {row.type_of_service} */}
                            </TableCell>
                            <TableCell sx={{ textAlign: "center" }}>
                              {row.arrival}
                            </TableCell>
                            <TableCell sx={{ textAlign: "center" }}>
                              {row.price}.00
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={4} sx={{ textAlign: "center" }}>
                            No Service Available For This Airport
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            ) : formValue?.arrival_departure_type?.value !== "Transit" &&
              formValue?.service_type?.value &&
              formValue?.airport?.value &&
              formValue?.arrival_departure_type?.value === "Departure" ? (
              <Grid item xs={12}>
                <TableContainer component={Paper} className="form-margin">
                  <Table
                    sx={{ minWidth: 600, border: "none" }}
                    aria-label="Services Table"
                  >
                    <TableHead>
                      <TableRow
                        sx={{
                          display: "grid",
                          gridTemplateColumns: "1fr 3fr 1fr",
                        }}
                      >
                        <TableCell scope="col">Services</TableCell>
                        <TableCell scope="col" sx={{ textAlign: "center" }}>
                          Departure
                        </TableCell>
                        <TableCell scope="col" sx={{ textAlign: "center" }}>
                          Price
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {tableContent?.length > 0 &&
                        tableContent[0]?.service !== undefined ? (
                        tableContent.map((row, index) => (
                          <TableRow
                            key={index}
                            sx={{
                              display: "grid",
                              gridTemplateColumns: "1fr 3fr 1fr",
                            }}
                          >
                            <TableCell>
                              {row.service}
                              {/* - {row.type_of_service} */}
                            </TableCell>
                            <TableCell sx={{ textAlign: "center" }}>
                              {row.departure}
                            </TableCell>
                            <TableCell sx={{ textAlign: "center" }}>
                              {row.price}.00
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={4} sx={{ textAlign: "center" }}>
                            No Service Available For This Airport
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            ) : formValue?.arrival_departure_type?.value === "Transit" &&
              formValue?.airport?.value &&
              formValue?.transit_service?.value >= 0 ? (
              <Grid item xs={12}>
                <TableContainer component={Paper} className="form-margin">
                  <Table
                    sx={{ minWidth: 600, border: "none" }}
                    aria-label="Services Table"
                  >
                    <TableHead>
                      <TableRow
                        sx={{
                          display: "grid",
                          gridTemplateColumns: "1fr 3fr 1fr",
                        }}
                      >
                        <TableCell scope="col">Services</TableCell>
                        <TableCell scope="col" sx={{ textAlign: "center" }}>
                          Transit
                        </TableCell>
                        <TableCell scope="col" sx={{ textAlign: "center" }}>
                          Price
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {tableContent?.length > 0 &&
                        tableContent[0]?.service !== undefined ? (
                        tableContent.map((row, index) => (
                          <TableRow
                            key={index}
                            sx={{
                              display: "grid",
                              gridTemplateColumns: "1fr 3fr 1fr",
                            }}
                          >
                            <TableCell>
                              {row.service}
                              {/* - {row.type_of_service} */}
                            </TableCell>
                            <TableCell sx={{ textAlign: "center" }}>
                              {row.transit}
                            </TableCell>
                            <TableCell sx={{ textAlign: "center" }}>
                              {row.price}.00
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={4} sx={{ textAlign: "center" }}>
                            No Service Available For This Airport
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            ) : (
              ""
            )}
            {/*Notes for Transit  */}
            {service === "Transit" && formValue?.transit_service?.value ? (
              <Grid item xs={12} sx={{}}>
                <Typography
                  component={Paper}
                  sx={{
                    textAlign: "center",
                    backgroundColor: "#f5f5f5",
                    padding: "20px",
                  }}
                  className="typography-message"
                >
                  <StarSymbol>Note: </StarSymbol>
                  "Transit service is available only if the time between the two
                  flights is minimum 3 hours to maximum 6 hours. For longer
                  layovers, please book two separate services."
                </Typography>
              </Grid>
            ) : (
              ""
            )}

            {(service === "Arrival" || service === "Departure") &&
              formValue?.service_type !== "" &&
              formValue?.airport?.value &&
              (service === "Arrival" ? arrivalField : departureField).map(
                (field, index) => (
                  <Grid item xs={12} sm={field.sm} key={index}>
                    <ControlledTextInputField
                      name={field.name}
                      control={control}
                      rules={field.rules}
                      type={field.type}
                      instantBooking={field.instantBooking}
                      label={field.label}
                      airportName={airport_name}
                      planeAvailable={tableContent > 0}
                      placeholder={field.placeholder}
                      options={field.options}
                      getOptionLabel={(option) => option.label || ""}
                      error={!!errors[field.name]}
                      helperText={errors[field.name]?.message}
                    />
                  </Grid>
                )
              )}

            {service === "Transit" &&
              formValue?.transit_service !== "" &&
              formValue?.transit_service?.value >= 0 &&
              transitField.map((field, index) => (
                <Grid item xs={12} sm={field.sm} key={index}>
                  <ControlledTextInputField
                    name={field.name}
                    control={control}
                    rules={field.rules}
                    type={field.type}
                    instantBooking={field.instantBooking}
                    planeAvailable={tableContent > 0}
                    label={field.label}
                    airportName={airport_name}
                    placeholder={field.placeholder}
                    options={field.options}
                    getOptionLabel={(option) => option.label || ""}
                    error={!!errors[field.name]}
                    helperText={errors[field.name]?.message}
                  />
                </Grid>
              ))}
            {/* Submit button */}
            <Grid item xs={12} className="button-container">
              <CustomButton
                variant="contained"
                className="grey-button"
                text="Back"
                onClick={() => {
                  let bookingsRoute;

                  if (user?.role === "Admin" || user?.role === "Staff") {
                    bookingsRoute = BOOKINGS;
                  } else if (user?.role === "Vendor") {
                    bookingsRoute = VENDOR_BOOKINGS;
                  } else if (user?.role === "Customer") {
                    bookingsRoute = CUSTOMER_BOOKINGS;
                  }

                  navigate(bookingsRoute);
                }}
              />
              <CustomButton
                variant="contained"
                className="orange-button"
                text="Next"
                type="submit"
              />
            </Grid>
          </Grid>
        </form>
      </Box>
    </Box>
  );
};
export default AirPortDetails;
